'use strict';

export default function bem(baseClass) {
    let _modifiers = [];
    let _otherClasses = [];
    const _bem = {
        modifier(...modifiers) {
            _modifiers = _modifiers.concat(modifiers.reduce((flat, modifier) => flat.concat(modifier), []).filter(modifier => !!modifier));
            return _bem;
        },
        element(name) {
            if (baseClass.indexOf('__') > -1) {
                throw new Error('Element nesting too deep, create a new component.');
            }
            return bem(`${baseClass}__${name}`);
        },
        withClass(...classes) {
            _otherClasses = _otherClasses.concat(classes.filter(className => className));
            return _bem;
        },
        toString() {
            return [baseClass]
                .concat(_modifiers.map(modifier => `${baseClass}--${modifier}`))
                .concat(_otherClasses)
                .join(' ');
        }
    };
    return _bem;
}



// WEBPACK FOOTER //
// ./common/bem.js